import { memo } from 'react';
import styled from '@emotion/styled';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

type Props = {
  children: React.ReactNode;
  className?: string;
  onClick: (e: React.MouseEvent) => void;
  sortable: boolean;
  sorted: 'asc' | 'desc' | false;
};

export const SortableHeader = memo(({ onClick, sorted, sortable, children, className }: Props) => {
  const desc = sorted === 'desc';

  return (
    <Root className={className} onClick={onClick}>
      {children}
      {sorted && !desc && <ArrowDropUpIcon />}
      {sorted && desc && <ArrowDropDownIcon />}
    </Root>
  );
});

SortableHeader.displayName = 'ProjectClips.SortableHeader';

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
